import { render, staticRenderFns } from "./upper-editor.vue?vue&type=template&id=77aa4126&scoped=true&"
import script from "./upper-editor.vue?vue&type=script&lang=js&"
export * from "./upper-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77aa4126",
  null
  
)

export default component.exports